<template>
    <kiosk-user-details :userId="props.userId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <page-header>Teams</page-header>

            <kiosk-teams-controls
                v-model="fetchParams"
                :sortingEnabled="false"
                @reset="resetFilters"
                @apply="applyFilters"
                :disableCreate="true"
            >
            </kiosk-teams-controls>

            <page-loading v-if="loading && !list.length"></page-loading>

            <empty-state v-else-if="!list.length && !isEqual(defaultFilters(), fetchParams)" @reset="resetFilters" />

            <div v-else-if="list.length">
                <kiosk-teams-table>
                    <kiosk-team-row v-for="(row, index) in list" v-model="list[index]" :key="row.id">
                        <template v-slot:actionItems>
                            <vx-dropdown-item
                                v-if="row.team_attributes?.contact_groups"
                                :href="`/kiosk/teams/${row.id}/users/${props.userId}/target-access`"
                                data-test="target-access"
                            >
                                Target Access
                                <font-awesome-icon :icon="faFingerprint"></font-awesome-icon>
                            </vx-dropdown-item>
                        </template>
                    </kiosk-team-row>
                </kiosk-teams-table>

                <div class="mt-8 flex justify-between w-full gap-10">
                    <vx-button
                        v-if="fetchParams.cursor"
                        @click="loadData()"
                        color="muted-dark"
                        size="xl"
                        class="grow-0"
                        data-test="load-more-btn"
                        :loading="loading"
                    >
                        Load More
                        <font-awesome-icon widthAuto :icon="faSpinner"></font-awesome-icon>
                    </vx-button>
                </div>
            </div>

            <empty-state v-else> No teams yet. </empty-state>
        </div>
    </kiosk-user-details>
</template>

<script setup>
import KioskUserDetails from './KioskUserDetails.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import EmptyState from '~/components/general/EmptyState.vue';
import { adminUsersClient } from '~/services/index';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { faFingerprint, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { VxButton, VxDropdownItem } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import KioskTeamsControls from '../../kiosk-teams/list/KioskTeamsControls.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import KioskTeamsTable from '../../kiosk-teams/list/KioskTeamsTable.vue';
import KioskTeamRow from '../../kiosk-teams/list/KioskTeamRow.vue';
import { isEqual } from '~/utils/helpers';

const props = defineProps({
    userId: {
        type: Number,
        required: true,
    },
});

const defaultFilters = () => ({
    query: '',
    cursor: null,
});

const { loading, list, fetchParams, fetchRecords } = useCursorPagination();

const resetFilters = () => {
    fetchParams.value = defaultFilters();
    loadData();
};

const applyFilters = () => {
    fetchParams.value = {
        ...fetchParams.value,
        cursor: null,
    };

    loadData();
};

const loadData = () => {
    fetchRecords(adminUsersClient.getUserTeams(props.userId, fetchParams.value));
};

resetFilters();
</script>
